import React from 'react';
import { Col, DatePicker, Form, Input, Row, Select } from 'antd';
import moment from 'moment';

const { Option } = Select;
const GRADE_OPTIONS = ['초1', '초2', '초3', '초4', '초5', '초6'];

const disabledReserveDate = (current) => {
  if (!current) return false;
  return current.isBefore(moment().startOf('day')) || current.day() === 0;
};

const CreatePlacementTestForm = ({ form, onFinish }) => {
  const handlePhoneChange = (event) => {
    form.setFieldsValue({ phone: event.target.value.replace(/[^0-9]/g, '') });
  };

  return (
    <Form form={form} layout="vertical" name="create-placement-test" onFinish={onFinish}>
      <Row gutter={[16, 0]}>
        <Col xs={24} md={12}>
          <Form.Item
            label="학생이름"
            name="student_name"
            rules={[{ required: true, whitespace: true, message: '학생이름을 입력해 주세요.' }]}
          >
            <Input size="large" maxLength={30} placeholder="학생이름" />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            label="학부모전화"
            name="phone"
            rules={[
              { required: true, message: '학부모전화 번호를 입력해 주세요.' },
              { pattern: /^\d{10,11}$/, message: '10~11자리 숫자만 입력해 주세요.' },
            ]}
          >
            <Input size="large" maxLength={11} placeholder="학부모전화" onChange={handlePhoneChange} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item label="학년" name="school_grade" rules={[{ required: true, message: '학년을 선택해 주세요.' }]}>
            <Select size="large" placeholder="학년 선택">
              {GRADE_OPTIONS.map((grade) => (
                <Option key={grade} value={grade}>
                  {grade}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            label="시험 예약일"
            name="reserve_date"
            rules={[{ required: true, message: '예약날짜를 선택해 주세요.' }]}
          >
            <DatePicker size="large" style={{ width: '100%' }} disabledDate={disabledReserveDate} inputReadOnly />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default CreatePlacementTestForm;
